var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav-drawer-base',{attrs:{"drawer":_vm.innerDrawer,"sectionData":_vm.sections},on:{"update:drawer":function($event){_vm.innerDrawer=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }